import {useMutation, useQueryClient} from '@tanstack/react-query'
import {MUTATION_KEYS} from '@/queryClient'
import {httpArchiveExport} from '@/features/exports/http/exports.http'
import {patchExportInCache} from '@/features/exports/query/exportsCache'
import {errorHandler} from '@/utilities/helpers'
import {toast} from '@/utilities/toast/toast'
import {useTranslation} from '@/translations/i18n'

/**
 * Archive (soft-delete / hide) an export job (FR-019). The returned archived job is
 * reconciled into the cached lists, which removes it from any list that hides archived.
 */
export const useArchiveExport = () => {
    const queryClient = useQueryClient()
    const {t} = useTranslation()

    return useMutation({
        mutationKey: [MUTATION_KEYS.ARCHIVE_EXPORT],
        mutationFn: (id: string) => httpArchiveExport(id),
        onSuccess: job => {
            patchExportInCache(queryClient, job)
            toast.success(t('exports:toast_archived'))
        },
        onError: errorHandler
    })
}
